import { createContext } from 'react';

export type AppMode = 'plan' | 'season';

export interface ModeContextType {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
}

export const ModeContext = createContext<ModeContextType>({
  mode: 'season',
  setMode: () => {}
});
